/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

/**
 * @module bulb-audio/bulbaudio
 */

import { Plugin } from 'ckeditor5';
import BulbAudioEditing from './bulbaudioediting';
import BulbAudioUi from './bulbaudioui';
import BulbAudioToolbar from './bulbaudiotoolbar';

/**
 * The audio plugin for Bulb's CKEditor.
 *
 * @extends module:core/plugin~Plugin
 */
export default class BulbAudio extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbAudioEditing, BulbAudioUi, BulbAudioToolbar] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbAudio' as const;
  }
}
